import React, { useState, useEffect, useRef } from "react"
import classNames from "classnames"
import { SmartCaptcha } from '@yandex/smart-captcha';

import { PhoneInput } from "../PhoneInput/PhoneInput"
import { ConsentCheckbox } from "../ConsentCheckbox/ConsentCheckbox"
import { TextInput } from "../TextInput"
import { EmailInput } from "../EmailInput"
import {
	registrationStartFormSendEvent,
	startTrialSendCodeEvent,
} from "../../../gtm-events"

import config from "../../../config"

import styles from "./styles.module.scss"

export enum ACTION_STATUSES {
	SENDING = "SENDING",
	NOT_SEND = "NOT_SEND",
	SUCCESS = "SUCCESS",
	FAIL = "FAIL",
}

function RegistrationForm(props) {
	const [actionStatus, setActionStatus] = useState<ACTION_STATUSES>(
		ACTION_STATUSES.NOT_SEND
	)
	const [isFormFilled, setIsFormFilled] = useState<boolean>(false)
	const [isCaptchaChecked, setIsCaptchaChecked] = useState<boolean>(false)


	useEffect(() => {
		if (Object.values(props.formData).slice(0, 4).every(field => field.isFilled) && isCaptchaChecked) {
			setIsFormFilled(true)
		} else {
			setIsFormFilled(false)
		}
	}, [props.formData, isCaptchaChecked])

	const setYcSuccess = (token :string) => {
		props.setYcToken(token)
		setIsCaptchaChecked(true)
	}


	const handleSubmit = e => {
		e.preventDefault()

		try {
			registrationStartFormSendEvent()
		} catch {
			console.log("gtm не найден")
		}

		props.setStep(2)

	}

	const onClickSubmit = () => {
		try {
			startTrialSendCodeEvent()
		} catch {
			console.log("gtm не найден")
		}
	}

	return (
		<form
			className={classNames(styles.registerForm, props.className)}
			onSubmit={handleSubmit}
		>
			{!props.noTitle && (
				<h1 className={styles.registerForm__title}>Зарегистрироваться</h1>
			)}

			<TextInput
				className={styles.registerForm__field}
				inputId="registerName"
				inputTitle="Ваше имя"
				value={props.formData.name.value}
				actionStatus={actionStatus}
				errorMessage={props.formData.name.errorMessage}
				onInputChange={(value, isInputFilled) =>
					props.onChangeFormField("name", value, isInputFilled)
				}
				extraProps={{
					required: true,
					autoFocus: true,
				}}
			/>

			<EmailInput
				className={styles.registerForm__field}
				inputId="registerEmail"
				inputTitle="Электронная почта"
				value={props.formData.email.value}
				actionStatus={actionStatus}
				errorMessage={props.formData.email.errorMessage}
				onInputChange={(value, isInputValid) =>
					props.onChangeFormField("email", value, isInputValid)
				}
				extraProps={{
					required: true,
				}}
			/>

			<PhoneInput
				className={styles.registerForm__field}
				inputId="registerPhone"
				inputTitle="Мобильный телефон"
				value={props.formData.phone.value}
				onInputChange={(value, isInputFilled) =>
					props.onChangeFormField("phone", value, isInputFilled)
				}
				actionStatus={actionStatus}
				errorMessage={props.formData.phone.errorMessage}
				extraProps={{
					required: true,
				}}
			/>

			<p
				className={classNames(
					styles.registerForm__promocodeBtn,
					styles.registerForm__field
				)}
				onClick={() => props.setIsShowPromocode(!props.isShowPromocode)}
			>
				{props.isShowPromocode
					? "У меня нет промокода"
					: "У меня есть промокод"}
			</p>

			{props.isShowPromocode && (
				<TextInput
					className={styles.registerForm__field}
					inputId="registerPromocode"
					inputTitle="Промокод"
					value={props.formData.promocode.value}
					type="text"
					actionStatus={actionStatus}
					errorMessage={props.formData.promocode.errorMessage}
					isHideOK={true}
					onInputChange={(value, isInputFilled) =>
						props.onChangeFormField("promocode", value, isInputFilled)
					}
				/>
			)}

			<ConsentCheckbox
				className={styles.registerForm__field}
				isAcceptedByDefault={true}
			/>

			<div
				className={styles.registerForm__captcha}
			>

			<SmartCaptcha
				sitekey={config.YANDEX_CAPTCHA_SITEKEY}
				onSuccess={setYcSuccess}
				shieldPosition={"bottom-right"}
				hideShield={false}
			/>

			</div>

			<button
				className={classNames(
					styles.registerForm__button,
					styles.registerForm__field
				)}
				onClick={onClickSubmit}
				type="submit"
				disabled={
					!isFormFilled ||
					actionStatus === ACTION_STATUSES.SUCCESS ||
					actionStatus === ACTION_STATUSES.SENDING
				}
			>
				Поехали!
			</button>
		</form>
	)
}

export default RegistrationForm
